// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stripeSessionId: __t.string().primaryKey().name("stripe_session_id"),
  userId: __t.u64().name("user_id"),
  purchaseType: __t.string().name("purchase_type"),
  packId: __t.option(__t.string()).name("pack_id"),
  tierId: __t.option(__t.u32()).name("tier_id"),
  createdAt: __t.u64().name("created_at"),
  fulfilled: __t.bool(),
});
